import { Typography, Stack, Grid } from '@mui/material';
import { Configure, InstantSearch } from 'react-instantsearch-hooks-web';
import { algoliaClient } from '@client/algolia';
import { Hits } from '@client/algolia/InstantSearch/Hits';
import { AlgoliaIndices } from '@sda/enums/algolia';
import { getAlgoliaIndexName } from '@sda/utils/algolia';
import { getDateRange } from '@sda/utils/date';
import { getEventLocation, getRoundedFollowers } from '@sda/utils/string';
import { useFormValues } from '@client/hooks/formik.hooks';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { ConnectCard } from '../common/ConnectCard';
import { showCallAttributesToRetrieve } from './FetchShowCalls/constants';
import { useFormFilter } from './FetchShowCalls/useFormFilter.hook';
import { FilterBar } from './FilterBar';
import type { AlgoliaBeacon } from '@sda/helpers/algolia.helpers';

const indexName = getAlgoliaIndexName(AlgoliaIndices.BEACONS_SCORE_DESC);

export const EmptyResults = () => {
  const isMobile = useIsMobile();
  const compiledAddress = useFormValues<string>('compiledAddress') || '';

  const filters = useFormFilter({ onlyFilterProfileType: true });
  const [searchCity] = compiledAddress.split(',') || [];

  return (
    <Stack spacing={isMobile ? 2 : 4}>
      <Stack spacing={3}>
        {!isMobile && (
          <div>
            <FilterBar />
          </div>
        )}

        <Typography
          variant="body2"
          color="disabled"
          align={isMobile ? 'center' : 'left'}
        >
          We couldn't find anything in
          {' '}

          {searchCity || 'the map area'}
          , but here are some nearby results.
        </Typography>
      </Stack>

      <InstantSearch
        searchClient={algoliaClient}
        indexName={indexName}
      >
        <Configure
          hitsPerPage={18}
          filters={filters}
          attributesToRetrieve={showCallAttributesToRetrieve}
          attributesToHighlight={[]}
          aroundLatLngViaIP
        />

        <div>
          <Hits<any, AlgoliaBeacon>
            component={Grid}
            container
            spacing={3}
            hitComponent={({ hit }) => (
              <Grid
                item
                xs={12}
                sm={6}
              >
                <ConnectCard
                  chipLabel={!hit.publicBeacon.isPublicCall && 'Private'}
                  imgSrc={hit.publicBeacon.profileData.publicImageUrl}
                  path={`/connect/${hit.objectID}`}
                  title={hit.publicBeacon.profileData.name}
                  location={getEventLocation(hit.publicBeacon)}
                  numReviews={hit.publicBeacon.profileData.numReviews}
                  score={hit.publicBeacon.profileData.score}
                  dateRange={getDateRange(hit.publicBeacon)}
                  isFeatured={hit.publicBeacon.isFeatured}
                  badge={hit.publicBeacon.profileData.badge}
                  spotifyMonthlyActiveListeners={getRoundedFollowers(hit.publicBeacon.profileData.spotifyMonthlyActiveListeners, 'compact')}
                />
              </Grid>
            )}
          />
        </div>
      </InstantSearch>
    </Stack>
  );
};
